export default "__VITE_ASSET__BJ8J8vxk__"